module.exports = __webpack_public_path__ + "img/臺中柳川旁.bb2d83ba.jpg";